export default "__VITE_ASSET__CTHzd0Fb__"